module.exports = __webpack_public_path__ + "img/qrcode.73445c7e.png";